import { Group, Loader, Paper, Text } from "@mantine/core";
import { FiCheck } from "react-icons/fi";
import classes from "./ToolCall.module.css";
import { V2ToolCall } from "../../api";

export interface ToolCallProps {
    toolCall: V2ToolCall;
}

export const ToolCall = ({ toolCall }: ToolCallProps) => {
    const isRunning = toolCall.statusValue === "running";
    const isFailed = toolCall.statusValue === "failed";
    const statusIcon = isRunning ? <Loader size={14} /> : isFailed ? <FiCheck size={14} color="red" /> : <FiCheck size={14} color="green" />;

    return (
        <Paper className={classes.toolCallContainer}>
            <Group gap="xs" wrap="nowrap">
                {statusIcon}
                <Text size="xs" fw={500} style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
                    {toolCall.results ? toolCall.results : toolCall.toolName}
                </Text>
                {toolCall.arguments && (
                    // miw={0} lets this flex item shrink below its content width; without
                    // it the implicit min-width:auto defeats the ellipsis and long
                    // arguments stretch the whole container horizontally.
                    <Text
                        size="xs"
                        c="dimmed"
                        ff="monospace"
                        miw={0}
                        title={toolCall.arguments}
                        style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                    >
                        {toolCall.arguments}
                    </Text>
                )}
            </Group>
        </Paper>
    );
};
